import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import {
  Image,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  Animated as ReactAnimated,
  FlatList,
  Modal,
  ActivityIndicator,
  Dimensions,
  TouchableHighlight,
} from 'react-native';
import Animated, {
  Easing,
  measure,
  runOnUI,
  useAnimatedRef,
  useAnimatedStyle,
  useDerivedValue,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import { createStackNavigator } from '@react-navigation/stack';
import { isTablet } from 'react-native-device-info';
import { EventRegister } from 'react-native-event-listeners';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import MenuComponent from '../../components/MenuComponent';
import AppContext from '../../navigation/Context';
import * as MenuNavigation from '../../navigation/MenuNavigation';
import colors from '../../resources/colors';
import images from '../../resources/images';
import { useToast } from 'react-native-toast-notifications';
import MenuScreen from '../menu/MenuScreen';
import { render } from 'react-dom';
import { addHours, closestIndexTo, format, isAfter, isBefore, parseISO, subDays } from 'date-fns';
import { useNavigation } from '@react-navigation/core';
import DataController from '../../controllers/DataController';
import FirebaseService from '../../controllers/FirebaseService';
import Collapsible from 'react-native-collapsible';
import _ from 'lodash';
import DropDownPicker from 'react-native-dropdown-picker';
import Popover, { PopoverPlacement } from 'react-native-popover-view';
import WebPicker from '../../components/WebPicker';
import DateTimePicker, { DateTimePickerAndroid } from '@react-native-community/datetimepicker';
import { FlashList } from '@shopify/flash-list';

const AnimatedKeyboardAwareScrollView = Animated.createAnimatedComponent(KeyboardAwareScrollView);

const DatePickerWeb = ({ initialDate, setInitialDate, scrollToDate, closePopover, minDate, maxDate }) => {
  const datePickerRef = useRef(null);
  const [currentDate, setCurrentDate] = useState(initialDate);

  const closeAndScroll = () => {
    scrollToDate(currentDate);
  };

  const onDateChanged = (date) => {
    setCurrentDate(date[0]);
    setInitialDate(date[0]);
  };

  return (
    <View
      style={{
        marginTop: 16
      }}>
      <WebPicker
        value={currentDate}
        onChange={(date) => onDateChanged(date)}
        style={{
          fontFamily: 'FiraSans-SemiBold',
          fontSize: 17,
          fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
          letterSpacing: 0.1,
          textAlign: 'center',
          color: colors.defaultText,
          borderWidth: 2,
          borderColor: colors.primary,
        }}
        minDate={minDate}
        maxDate={maxDate}
      />
      <TouchableOpacity
        onPress={() => closeAndScroll()}
        style={{
          height: 50,
          width: 220,
          borderRadius: 8,
          backgroundColor: colors.blue,
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 16,
          alignSelf: 'center',
        }}>
        <Text
          allowFontScaling={false}
          style={{
            fontFamily: 'FiraSans-SemiBold',
            fontSize: 17,
            fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
            lineHeight: 24,
            letterSpacing: 0.1,
            textAlign: 'center',
            color: colors.accentWhite,
          }}>
          {'Scroll to date'}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const CustomDatePickerIOS = ({ initialDate, setInitialDate, scrollToDate, closePopover, minDate, maxDate }) => {
  const datePickerRef = useRef(null);
  const [currentDate, setCurrentDate] = useState(initialDate);

  const closeAndScroll = () => {
    scrollToDate(currentDate);
  };

  const onDateChanged = (event, date) => {
    setCurrentDate(date);
    setInitialDate(date);
  }

  return (
    <View
      style={{
        marginTop: 16,
        width: 300,
      }}>
      <DateTimePicker
        style={{
          height: 300,
        }}
        value={currentDate}
        onChange={onDateChanged}
        mode="date"
        display="inline"
        minimumDate={minDate}
        maximumDate={maxDate}
      />
      <TouchableOpacity
        onPress={() => closeAndScroll()}
        style={{
          height: 50,
          width: 220,
          borderRadius: 8,
          backgroundColor: colors.blue,
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 16,
          alignSelf: 'center',
        }}>
        <Text
          allowFontScaling={false}
          style={{
            fontFamily: 'FiraSans-SemiBold',
            fontSize: 17,
            fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
            lineHeight: 24,
            letterSpacing: 0.1,
            textAlign: 'center',
            color: colors.accentWhite,
          }}>
          {'Scroll to date'}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const Filter = ({
  headerText,
  defaultButtonText,
  filterIndex,
  options,
  zIndex,
  zIndexInverse,
  updateOptions,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    EventRegister.addEventListener('filter/clear-all', () => {
      setSelectedOption(null);
      setOpen(false);
    });

    EventRegister.addEventListener('filter/close-filter', (_index) => {
      if (filterIndex !== _index) {
        setOpen(false);
      }
    });

    return () => {
      EventRegister.removeEventListener('filter/clear-all');
      EventRegister.removeEventListener('filter/close-filter');
    };
  });

  const borderStyles = StyleSheet.create({
    borders: {
      borderBottomLeftRadius: open ? 0 : 4,
      borderBottomRightRadius: open ? 0 : 4,
    }
  });

  const onSelectItem = (item) => updateOptions(item);

  const onOpen = () => EventRegister.emit('filter/close-filter', filterIndex);

  return (
    <View style={{
      flex: (isTablet() || Platform.OS === 'web') && Dimensions.get('window').width > 850 ? 1 : undefined,
      marginEnd: (isTablet() || Platform.OS === 'web') && Dimensions.get('window').width > 850 ? 8 : 0,
      marginBottom: (isTablet() || Platform.OS === 'web') && Dimensions.get('window').width > 850 ? 0 : 8,
      zIndex,
    }}>
      <Text style={styles.filtersHeaderText}>
        {headerText}
      </Text>
      <DropDownPicker
        open={open}
        setOpen={setOpen}
        items={options}
        value={selectedOption}
        setValue={setSelectedOption}
        // zIndex={zIndex}
        // zIndexInverse={zIndexInverse}
        placeholder={defaultButtonText}
        onSelectItem={onSelectItem}
        onOpen={onOpen}
        style={{
          backgroundColor: colors.accentWhite,
          borderColor: colors.primary,
          borderWidth: 2,
          borderRadius: 4,
          height: 44,
          zIndex: 100
        }}
        textStyle={{
          fontFamily: 'FiraSans-Regular',
          fontSize: 17,
          fontWeight: 'normal',
          fontStyle: 'normal',
          letterSpacing: 0,
          color: colors.defaultText,
        }}
        itemProps={{
          activeOpacity: 0.6,
          style: {
            height: 44,
            alignItems: 'center',
            flexDirection: 'row',
            paddingHorizontal: 8,
          }
        }}
        labelStyle={{
          fontFamily: 'FiraSans-Regular',
          fontSize: 17,
          fontWeight: 'normal',
          fontStyle: 'normal',
          letterSpacing: 0,
          color: colors.defaultText,
          // lineHeight: 44,
        }}
        labelProps={{
          numberOfLines: 1,
        }}
        placeholderStyle={{
          fontFamily: 'FiraSans-Regular',
          fontSize: 17,
          fontWeight: 'normal',
          fontStyle: 'normal',
          letterSpacing: 0,
          color: colors.grey60,
        }}
        dropDownContainerStyle={{
          borderColor: colors.primary,
          borderWidth: 2,
          borderTopWidth: 1,
          minHeight: 250,
          position: 'absolute',
          zIndex: 1000,
        }}
        ArrowDownIconComponent={() => (
          <Image
            source={images.Button_Collapse_Red}
            style={{ height: 44, width: 44, marginEnd: -8 }}
          />
        )}
        ArrowUpIconComponent={() => (
          <Image
            source={images.Button_Collapse_Red}
            style={{ height: 44, width: 44, marginEnd: -8, transform: [{ rotateX: '180deg' }] }}
          />
        )}
        flatListProps={{
          ItemSeparatorComponent: () => <View style={{ height: 2, backgroundColor: colors.primary }} />
        }}
      />
    </View>
  );

  return (
    <View style={styles.filterContainer}>
      <Text style={styles.filtersHeaderText}>
        {headerText}
      </Text>
      <TouchableOpacity
        style={[styles.filterButton, borderStyles.borders]}
        activeOpacity={0.5}
        onPress={() => setOpen(!open)}>
        <Text style={styles.filterButtonText} allowFontScaling={false}>
          {defaultButtonText}
        </Text>
        <Image source={images.Button_Collapse_Red} />
      </TouchableOpacity>
    </View>
  );
};

const Filters = ({ days, setFilters }) => {
  const _months =
    [
      { type: 'month', label: 'All Months', value: 'all' },
      { type: 'month', label: 'January', value: 'January' },
      { type: 'month', label: 'February', value: 'February' },
      { type: 'month', label: 'March', value: 'March' },
      { type: 'month', label: 'April', value: 'April' },
      { type: 'month', label: 'May', value: 'May' },
      { type: 'month', label: 'June', value: 'June' },
      { type: 'month', label: 'July', value: 'July' },
      { type: 'month', label: 'August', value: 'August' },
      { type: 'month', label: 'September', value: 'September' },
      { type: 'month', label: 'October', value: 'October' },
      { type: 'month', label: 'November', value: 'November' },
      { type: 'month', label: 'December', value: 'December' },
    ]

  const _events = [
    { type: 'event', label: 'All Events', value: 'all' },
    { type: 'event', label: 'Sundays only', value: 'Sundays only' },
    { type: 'event', label: 'Sundays, Principal Feasts & Holy Days', value: 'Sundays, Principal Feasts & Holy Days' },
    { type: 'event', label: 'Principal Feasts & Holy Days only', value: 'Principal Feasts & Holy Days only' },
    { type: 'event', label: 'Festival', value: 'Festival' },
    { type: 'event', label: 'Lesser Festival', value: 'Lesser Festival' },
    { type: 'event', label: 'Commemoration', value: 'Commemoration' },
    { type: 'event', label: 'Mandatory celebrations', value: 'Mandatory celebrations' },
    { type: 'event', label: 'Optional celebrations', value: 'Optional celebrations' },
  ];

  const _seasons = [
    { type: 'season', label: 'All Seasons', value: 'all' },
    { type: 'season', label: 'Advent', value: 'Advent' },
    { type: 'season', label: 'Christmas', value: 'Christmas' },
    { type: 'season', label: 'Epiphany', value: 'Epiphany' },
    { type: 'season', label: 'Before Lent', value: 'Before Lent' },
    { type: 'season', label: 'Lent', value: 'Lent' },
    { type: 'season', label: 'Holy Week', value: 'Holy Week' },
    { type: 'season', label: 'Easter', value: 'Easter' },
    { type: 'season', label: 'Pentecost', value: 'Pentecost' },
    { type: 'season', label: 'Trinity', value: 'Trinity' },
    { type: 'season', label: "All Saints' to Advent", value: "All Saints' to Advent" },
  ];

  const _years =
    [
      { type: 'year', label: 'All years', value: 'all' },
      { type: 'year', label: '2024 - 2025 (Year C)', value: 2025 },
      { type: 'year', label: '2023 - 2024 (Year B)', value: 2024 },
      { type: 'year', label: '2022 - 2023 (Year A)', value: 2023 },
      { type: 'year', label: '2021 - 2022 (Year C)', value: 2022 },
      { type: 'year', label: '2020 - 2021 (Year B)', value: 2021 },
      { type: 'year', label: '2019 - 2020 (Year C)', value: 2020 },
      { type: 'year', label: 'Show from now', value: 'now' },
    ];

  const [options, setOptions] = useState([]);
  const [eventTypes, setEventTypes] = useState(_events);
  const [seasons, setSeasons] = useState(_seasons);
  const [years, setYears] = useState(_years);
  const [months, setMonths] = useState(_months);

  const resetFilters = () => {
    setOptions([]);
    setFilters([]);
    EventRegister.emit('filter/clear-all');
    EventRegister.emit('filter/close-filter');
  };

  const updateOptions = (option) => {
    const _options = _.cloneDeep(options);
    const index = _options.findIndex((_option) => _option.type === option.type);

    if (index > -1) {
      _options.splice(index, 1, option);
    } else {
      _options.push(option);
    }

    setOptions(_options);
    setFilters(_options);
  };

  const showClear = options.length > 0;

  return (
    <View style={styles.filtersContainer}>
      <View style={{
        width: '100%',
        maxWidth: 1400,
      }}>
        <View style={{
          flexDirection: (isTablet() || Platform.OS === 'web') && Dimensions.get('window').width > 850 ? 'row' : 'column',
          justifyContent: 'space-between',
          marginEnd: (isTablet() || Platform.OS === 'web') && Dimensions.get('window').width > 850 ? -8 : 0,
          marginBottom: (isTablet() || Platform.OS === 'web') && Dimensions.get('window').width > 850 ? 0 : -8,
        }}>
          <Filter
            headerText={'Event type'}
            defaultButtonText={'All Events'}
            filterIndex={1}
            options={eventTypes}
            zIndex={4000}
            zIndexInverse={1000}
            updateOptions={updateOptions}
          />
          <Filter
            headerText={'Season'}
            defaultButtonText={'All Seasons'}
            filterIndex={2}
            options={seasons}
            zIndex={3000}
            zIndexInverse={2000}
            updateOptions={updateOptions}
          />
          <Filter
            headerText={'Year'}
            defaultButtonText={'Show from now'}
            filterIndex={3}
            options={years}
            zIndex={2000}
            zIndexInverse={3000}
            updateOptions={updateOptions}
          />
          <Filter
            headerText={'Month'}
            defaultButtonText={'All Months'}
            filterIndex={4}
            options={months}
            zIndex={1000}
            zIndexInverse={4000}
            updateOptions={updateOptions}
          />
          <TouchableOpacity
            activeOpacity={0.6}
            style={[styles.resetButton, {
              opacity: showClear ? 1 : 0.3,
              alignSelf: 'flex-end',
              marginStart: (isTablet() || Platform.OS === 'web') && Dimensions.get('window').width > 850 ? 4 : 0,
              marginTop: (isTablet() || Platform.OS === 'web') && Dimensions.get('window').width > 850 ? 0 : 15,
            }]}
            onPress={resetFilters}
            disabled={!showClear}>
            <Text style={styles.resetText} allowFontScaling={false}>
              {'Reset'}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

const Row = ({ day, bookmarks, notes }) => {
  if (day.header) {
    return (
      <View style={styles.stickyHeader}>
        <Text style={styles.stickyTitle} allowFontScaling={false}>
          {day.WeekTitle}
        </Text>
      </View>
    );
  }

  const navigation = useNavigation();
  const context = useContext(AppContext);
  const { days } = context;
  const dayIndex = days.findIndex((item) => item.Date === day.Date);

  let background = day.Colour && (day.Colour === 'Hangings removed' ? 'grey' : day.Colour.split(/[ |\/]/gmi)[0].toLowerCase());
  const backgroundHex = DataController.colourNameToHex(background);
  const textColor = backgroundHex ? DataController.getTextColor(backgroundHex) : colors.accentWhite;

  const bookmarked = bookmarks.findIndex((bookmark) => bookmark === day.id) > -1;
  const noted = notes.findIndex((note) => note.id === day.id) > -1;

  // __DEV__ && (day.Event && day.Event[0].option) && console.log(day.Event[0].option);

  const dropdownStyle = (day.Event && day.Event[0].option) ? DataController.getDropdownStyle(day.Event[0].option) : {};
  const eventShouldShowOption = (day.Event && day.Event[0].option) ? DataController.eventShouldShowOption(day.Event[0].option) : false;

  const time = new Date(new Date(day.Date).valueOf());

  return (
    <View style={{
      maxWidth: 1400,
      alignSelf: 'center',
      width: isTablet() || Platform.OS === 'web'
        ? Dimensions.get('window').width - 60
        : Dimensions.get('window').width - 30,
    }}>
      <TouchableHighlight
        underlayColor={colors.buttonHighlight}
        style={styles.browseRow}
        activeOpacity={0.5}
        onPress={() => {
          !__DEV__ && FirebaseService.logEvent('day_viewed', { date: day.Date });
          navigation.navigate('Day', { day, dayIndex })
          EventRegister.emit('filter/close-filter');
        }}>
        <View>
          <View>
            <Text style={styles.title} allowFontScaling={false}>
              {format(parseISO(day.Date), 'EEEE d MMMM yyyy')}
            </Text>
            <Text style={styles.caption} allowFontScaling={false}>
              {day.WeekTitle}
            </Text>
            {day.Event && (
              <>
                <Text style={[styles.caption2, dropdownStyle]} allowFontScaling={false} numberOfLines={1}>
                  {day.Event[0].data}{eventShouldShowOption && ` (${day.Event[0].option})`}
                </Text>
              </>
            )}
          </View>
          <View style={styles.bottomContainer}>
            {day.Colour ? (
              <View
                style={[
                  styles.color,
                  // eslint-disable-next-line react-native/no-inline-styles
                  {
                    height: day.Colour === 'White' ? 18 : 16,
                    backgroundColor: backgroundHex ? backgroundHex : 'grey',
                    borderWidth: day.Colour === 'White' ? 1 : 0,
                  },
                ]}>
                <Text style={[styles.colorText, { color: textColor }]} allowFontScaling={false}>
                  {day.Colour}
                </Text>
              </View>
            ) : (
              <View />
            )}
            <View style={{ flexDirection: 'row' }}>
              {noted && <Image style={styles.icon} source={images.Button_Notes_Active} />}
              {bookmarked && <Image style={styles.icon} source={images.Button_Bookmark_Active} />}
            </View>
          </View>
        </View>
      </TouchableHighlight>
    </View>
  );
};

const renderSeparator = () => (
  <View
    style={[styles.separator, {
      width: isTablet() || Platform.OS === 'web'
        ? Dimensions.get('window').width - 60
        : Dimensions.get('window').width - 30,
    }]}
  />
);

const BrowseScreen = ({ navigation }) => {
  const flatList = useRef(null);
  const datePicker = useRef(null);
  const toast = useToast();

  const context = useContext(AppContext);
  let days = context.days;
  __DEV__ && console.log('BrowseScreen', subDays(new Date(), 1));
  days = days.filter((day) => isAfter(parseISO(day.Date), subDays(new Date(), 1)));

  const menuWidth = 375;
  const menuOffset = useSharedValue(-menuWidth);
  const screenOffset = useSharedValue(0);
  const menuBackgroundOffset = useSharedValue(0);

  const [menuOpen, setMenuOpen] = useState(false);
  const [bookmarks, setBookmarks] = useState([]);
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState([]);
  const [filtersOpen, setFiltersOpen] = useState(Platform.OS === 'web' || isTablet() && Dimensions.get('window').width > 1080);
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [daysToShow, setDaysToShow] = useState(days);
  const [initialDate, setInitialDate] = useState(new Date());
  const [androidPickerVisible, setAndroidPickerVisible] = useState(false);

  useEffect(() => {
    getBookmarks();
  }, []);

  useEffect(() => {
    getNotes();
  }, []);

  useEffect(() => {
    let _days = context.days;

    if (filters.length === 0) {
      _days = _days.sort((a, b) => new Date(a.Date) - new Date(b.Date));
      _days = _days.filter((day) => isAfter(parseISO(day.Date), subDays(new Date(), 1)));
    } else {
      let yearOption = filters.find((filter) => filter.type === 'year');
      let eventOption = filters.find((filter) => filter.type === 'event');
      let seasonOption = filters.find((filter) => filter.type === 'season');
      let monthOption = filters.find((filter) => filter.type === 'month');

      if (!yearOption || yearOption.value === 'now') {
        _days = _days.filter((day) => isAfter(new Date(day.Date), subDays(new Date(), 1)));
      } else {
        switch (yearOption.value) {
          case 'all':
            break;
            case 2025:
              _days = _days.filter((day) => {
                let id = day.id ? parseInt(day.id.split(':')[1], 10) : undefined;
                return id ? id >= 4740 && id < 5138 : false;
              });
              break;
          case 2024:
            _days = _days.filter((day) => {
              let id = day.id ? parseInt(day.id.split(':')[1], 10) : undefined;
              return id ? id >= 4341 && id < 4740 : false;
            });
            break;
          case 2023:
            _days = _days.filter((day) => {
              let id = day.id ? parseInt(day.id.split(':')[1], 10) : undefined;
              return id ? id >= 3931 && id < 4341 : false;
            });
            break;
          case 2022:
            _days = _days.filter((day) => {
              let id = day.id ? parseInt(day.id.split(':')[1], 10) : undefined;
              return id ? id >= 3530 && id < 3931 : false;
            });
            break;
          case 2021:
            _days = _days.filter((day) => {
              let id = day.id ? parseInt(day.id.split(':')[1], 10) : undefined;
              return id ? id >= 3128 && id < 3530 : false;
            });
            break;
          case 2020:
            _days = _days.filter((day) => {
              let id = day.id ? parseInt(day.id.split(':')[1], 10) : undefined;
              return id ? id >= 2739 && id < 3127 : false;
            });
            break;
        }
      }

      if (monthOption && monthOption.value !== 'all') {
        _days = _days.filter((day) => format(new Date(new Date(addHours(new Date(day.Date), 12))), 'MMMM') === monthOption.value);
      }

      if (eventOption) {
        switch (eventOption.value) {
          case 'all':
            break;
          case 'Sundays only':
            _days = _days.filter((day) => day.DayOfWeek === 'Sunday');
            break;
          case 'Sundays, Principal Feasts & Holy Days':
            let allowedEvents = ['Principal Feast', 'Principal Holy Day'];
            _days = _days.filter((day) => {
              let events = day.Event ? day.Event.map((event) => event.option) : [];
              return day.DayOfWeek === 'Sunday' || _.intersection(events, allowedEvents).length > 0;
            });
            break;
          case 'Principal Feasts & Holy Days only':
            allowedEvents = ['Principal Feast', 'Principal Holy Day'];
            _days = _days.filter((day) => {
              let events = day.Event ? day.Event.map((event) => event.option) : [];
              return _.intersection(events, allowedEvents).length > 0;
            });
            break;
          case 'Festival':
          case 'Lesser Festival':
          case 'Commemoration':
            _days = _days.filter((day) => {
              let events = day.Event ? day.Event.map((event) => event.option) : [];
              return events.includes(eventOption.value);
            });
            break;
          case 'Mandatory celebrations':
            allowedEvents = ['Principal Feast', 'Principal Holy Day', 'Festival'];
            _days = _days.filter((day) => {
              let events = day.Event ? day.Event.map((event) => event.option) : [];
              return _.intersection(events, allowedEvents).length > 0;
            });
            break;
          case 'Optional celebrations':
            allowedEvents = ['Lesser Festival', 'Commemoration'];
            _days = _days.filter((day) => {
              let events = day.Event ? day.Event.map((event) => event.option) : [];
              return _.intersection(events, allowedEvents).length > 0;
            });
            break;
        }
      }

      if (seasonOption) {
        switch (seasonOption.value) {
          case 'all':
            break;
          case 'Advent':
          case 'Christmas':
          case 'Epiphany':
          case 'Before Lent':
          case 'Holy Week':
          case 'Easter':
          case 'Pentecost':
          case 'Trinity':
            let regex = new RegExp(seasonOption.value, 'i');

            _days = _days.filter((day) => (
              day.WeekTitle.indexOf('before Advent') === -1 && regex.test(day.WeekTitle)
            ));
            break;
          case 'Lent':
            _days = _days.filter((day) => day.WeekTitle.indexOf('Lent') === 0);
            break;
          case "All Saints' to Advent":
            _days = _days.filter((day) => day.WeekTitle.indexOf('before Advent') > 0);
            break;
        }
      }
    }

    setDaysToShow(_days);
  }, [filters]);

  useEffect(() => {
    if (filters.length === 0) {
      console.log('INDEX: ', DataController.formatDate(new Date()));

      const index = days.findIndex((_day) => _day.Date === DataController.formatDate(new Date()));

      __DEV__ && console.log('BrowseScreen', index);
      if (index > -1) {
        try {
          flatList.current.scrollToIndex({ index, animated: true, viewPosition: 0 });
        } catch (error) {
          console.log(error);
        }
      }
    }
  }, [filters]);

  useEffect(() => {
    EventRegister.addEventListener('bookmarks/updated', getBookmarks);
    EventRegister.addEventListener('notes/updated', getNotes);

    return () => {
      EventRegister.removeEventListener('bookmarks/updated');
      EventRegister.removeEventListener('notes/updated');
    }
  }, []);

  const getBookmarks = async () => {
    __DEV__ && console.log('updateBookmarks');

    DataController.getBookmarks().then((_bookmarks) => setBookmarks(_bookmarks));
  };

  const getNotes = async () => {
    DataController.getAllNotes().then((_notes) => setNotes(_notes));
  };

  useEffect(() => {
    navigation.setOptions({
      headerLeft: () => (
        <View style={styles.headerRow}>
          <TouchableOpacity style={styles.backButton} onPress={() => navigation.goBack()}>
            <Image style={styles.menuIcon} source={images.Button_Back} />
            <Text style={styles.backButtonText} allowFontScaling={false}>
              {'Back'}
            </Text>
          </TouchableOpacity>
        </View>
      ),
      headerTitle: () => isTablet() || Platform.OS === 'web' ? (
        <View style={styles.headerTitleContainer}>
          <Text style={styles.headerTitle} allowFontScaling={false}>
            {'Browse all dates'}
          </Text>
        </View>
      ) : <View />,
      headerRight: () => (
        <View style={styles.headerRow}>
          <TouchableOpacity style={styles.buttonMenu} onPress={() => filterPressed(!filtersOpen)}>
            <Image style={styles.menuIcon} source={images.Button_Filter} />
          </TouchableOpacity>
          <Popover
            popoverStyle={{
              borderRadius: 8,
            }}
            isVisible={popoverVisible}
            onRequestClose={() => setPopoverVisible(false)}
            placement={PopoverPlacement.BOTTOM}
            from={(
              <TouchableOpacity style={styles.buttonMenu} onPress={() => calendarPressed()}>
                <Image style={styles.menuIcon} source={images.Button_Calendar_Red} />
              </TouchableOpacity>
            )}>
            <View style={styles.popoverContainer}>
              {Platform.OS === 'web' && (
                <>
                  <DatePickerWeb
                    closePopover={closePopover}
                    maxDate={new Date(daysToShow[daysToShow.length - 1]?.Date)}
                    minDate={new Date(daysToShow[0]?.Date)}
                    initialDate={initialDate}
                    setInitialDate={(date) => setInitialDate(date)}
                    scrollToDate={scrollToDate}
                  />
                </>
              )}
              {Platform.OS === 'ios' && (
                <>
                  <CustomDatePickerIOS
                    closePopover={closePopover}
                    maxDate={new Date(daysToShow[daysToShow.length - 1]?.Date)}
                    minDate={new Date(daysToShow[0]?.Date)}
                    initialDate={initialDate}
                    setInitialDate={(date) => setInitialDate(date)}
                    scrollToDate={scrollToDate}
                  />
                </>
              )}
            </View>
          </Popover>
        </View>
      ),
      headerTitleAlign: 'center',
      headerStyle: {
        backgroundColor: colors.grey20,
        shadowRadius: 0,
        shadowOffset: {
          height: 0,
        },
        borderBottomWidth: 0.5,
        borderBottomColor: colors.grey50,
        height: Platform.OS === 'web' ? 44 : undefined,
      },
    });
  }, [filterPressed, calendarPressed, closePopover, popoverVisible, navigation, filtersOpen]);

  const closePopover = useCallback(() => {
    if (Platform.OS === 'android') {
      setAndroidPickerVisible(false);
    } else {
      setPopoverVisible(false);
    }
  }, []);

  const openMenu = useCallback(() => {
    EventRegister.emit('menu/toggle-contents');
  }, []);

  const filterPressed = useCallback((value) => {
    setFiltersOpen(value);
    EventRegister.emit('filter/close-filter');
  }, [toast, setFiltersOpen]);

  const onDateChanged = (event, _date) => {
    setInitialDate(_date);
    scrollToDate(_date);
  }

  const calendarPressed = useCallback(() => {
    if (Platform.OS === 'android') {
      DateTimePickerAndroid.open({
        value: initialDate,
        onChange: onDateChanged,
        mode: 'date',
        minimumDate: new Date(daysToShow[0]?.Date).getTime(),
        maximumDate: new Date(daysToShow[daysToShow.length - 1]?.Date).getTime(),
      });

    } else {
      setPopoverVisible(true);
    }
  }, [setAndroidPickerVisible, setPopoverVisible, daysToShow]);


  const renderItem = ({ item, index }) => {
    return <Row day={item} notes={notes} bookmarks={bookmarks} />;
  };

  const keyExtractor = (item, index) => `${item.Date}-${index}`;

  const setNewFilters = (_filters) => {
    setFilters(_filters);
  }

  const scrollToDate = (date) => {
    const formattedDate = DataController.formatDate(date);
    let index = closestIndexTo(date, daysToShow.map((item) => new Date(item.Date)));

    if (index > -1) {
      try {
        flatList.current.scrollToIndex({ index, animated: true, viewPosition: 0 });
      } catch (error) {
        console.log(error);
      }
    }

    closePopover();
  }

  __DEV__ && console.log(daysToShow.length);

  return (
    <View style={styles.container}>
      <Collapsible
        collapsed={!filtersOpen}
        renderChildrenCollapsed={true}
        style={{
          overflow: filtersOpen ? 'visible' : 'hidden',
          zIndex: 50,
        }}>
        <Filters days={days} setFilters={setNewFilters} />
      </Collapsible>
      <View style={{ flex: 1, zIndex: -1 }}>
        <FlashList
          ref={flatList}
          data={daysToShow}
          renderItem={renderItem}
          keyExtractor={keyExtractor}
          estimatedItemSize={124}
          ItemSeparatorComponent={renderSeparator}
          initialNumToRender={10}
          removeClippedSubviews
          contentContainerStyle={{ paddingBottom: 54 }}
          indicatorStyle="black"
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.accentWhite,
    flex: 1,
    height: '100%',
  },
  loadingContainer: {
    flex: 1,
    backgroundColor: colors.accentWhite,
    alignItems: 'center',
    justifyContent: 'center',
  },
  loading: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 24,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 30,
    letterSpacing: -0.1,
    textAlign: 'center',
    color: colors.primary,
    marginTop: 10,
  },
  scrollViewContainer: {
    paddingBottom: 54,
    width: '100%',
    maxWidth: 1400,
    alignSelf: 'center',
  },
  innerContainer: {
    width: '100%',
    maxWidth: 1400,
  },
  backButton: {
    flexDirection: 'row',
    marginStart: 4,
    alignItems: 'center',
  },
  backButtonText: {
    fontFamily: 'FiraSans-Regular',
    fontSize: 17,
    fontWeight: 'normal',
    color: colors.primary,
    marginStart: -5,
  },
  headerRow: {
    flexDirection: 'row',
  },
  buttonMenu: {
    width: 44,
    height: 44,
    marginStart: 4,
  },
  menuIcon: {
    width: 44,
    height: 44,
    tintColor: colors.primary,
  },
  browseRow: {
    height: 124,
    justifyContent: 'space-between',
    paddingTop: 12,
    paddingBottom: 4,
  },
  separator: {
    height: 2,
    backgroundColor: colors.grey30,
    maxWidth: 1400,
    alignSelf: 'center',
  },
  title: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 20,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 28,
    letterSpacing: -0.1,
    color: colors.defaultText,
    marginBottom: 4,
    maxWidth: '80%',
  },
  color: {
    left: 0,
    bottom: 0,
    borderRadius: 9,
    backgroundColor: '#009900',
    height: 16,
    paddingHorizontal: 6,
    justifyContent: 'center',
    alignSelf: 'center',
  },
  colorText: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 12,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 16,
    letterSpacing: -0.1,
    color: colors.accentWhite,
  },
  caption: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 12,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 16,
    letterSpacing: 0.2,
    color: colors.defaultText,
  },
  caption2: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 11,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 14,
    letterSpacing: 0.1,
    color: colors.defaultText,
    marginTop: 5,
  },
  bottomContainer: {
    // position: 'absolute',
    // bottom: 0,
    height: 44,
    flexDirection: 'row',
    justifyContent: 'space-between',
    // backgroundColor: colors.accentBlack,
  },
  icon: {
    width: 44,
    height: 44,
    marginStart: 5,
  },
  filtersContainer: {
    // height: 500,
    backgroundColor: colors.grey20,
    shadowColor: colors.grey50,
    shadowOffset: {
      width: 0,
      height: -0.5
    },
    shadowRadius: 0,
    shadowOpacity: 1,
    borderBottomWidth: 1,
    borderBottomColor: colors.grey50,
    paddingHorizontal: isTablet() || Platform.OS === 'web' ? 30 : 15,
    paddingVertical: 16,
    overflow: 'visible',
    zIndex: 2,
    alignItems: 'center',
  },
  filtersTextContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 4,
  },
  filtersText: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 15,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 20,
    letterSpacing: 0,
    color: colors.defaultText,
  },
  resetButton: {
    width: 90,
    height: 48,
    borderRadius: 4,
    backgroundColor: colors.accentWhite,
    borderStyle: "solid",
    borderWidth: 2,
    borderColor: colors.primary,
    justifyContent: 'center',
    alignItems: 'center',
  },
  resetText: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 15,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 20,
    letterSpacing: 0,
    color: colors.defaultText,
  },
  filterOuterContainer: {
    flexDirection: (isTablet() || Platform.OS === 'web') && Dimensions.get('window').width > 850 ? 'row' : 'column',
    justifyContent: 'space-between',
    marginEnd: (isTablet() || Platform.OS === 'web') && Dimensions.get('window').width > 850 ? -8 : 0,
    marginBottom: (isTablet() || Platform.OS === 'web') && Dimensions.get('window').width > 850 ? 0 : -8,
  },
  filterContainer: {
    flex: (isTablet() || Platform.OS === 'web') && Dimensions.get('window').width > 850 ? 1 : undefined,
    marginEnd: (isTablet() || Platform.OS === 'web') && Dimensions.get('window').width > 850 ? 8 : 0,
    marginBottom: (isTablet() || Platform.OS === 'web') && Dimensions.get('window').width > 850 ? 0 : 8,
  },
  filtersHeaderText: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 12,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 16,
    letterSpacing: 0.2,
    color: colors.defaultText,
    marginBottom: 4,
  },
  filterButton: {
    height: 44,
    // flexDirection: 'row',
    // justifyContent: 'space-between',
    // alignItems: 'center',
    paddingStart: 10,
    borderRadius: 4,
    backgroundColor: colors.accentWhite,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: colors.primary,
  },
  filterButtonText: {
    flex: 1,
    fontFamily: 'FiraSans-Regular',
    fontSize: 17,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: 26,
    letterSpacing: 0,
    color: colors.grey60,
  },
  filterDropdown: {
    position: 'absolute',
    width: '100%',
    minHeight: 50,
    maxHeight: 200,
    backgroundColor: colors.accentWhite,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    borderColor: colors.primary,
    zIndex: 100,
  },
  overlay: {
    width: '100%',
    height: '100%',
  },
  dropdownRowContainer: {
    height: 44,
    justifyContent: 'center',
    paddingStart: 10,
  },
  dropdownRow: {
    // flex: 1,
    fontFamily: 'FiraSans-Regular',
    fontSize: 17,
    fontWeight: 'normal',
    fontStyle: 'normal',
    letterSpacing: 0,
    lineHeight: 44,
    color: colors.defaultText,
  },
  dropdownStyle: {
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderRadius: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    borderColor: colors.primary,
    borderTopWidth: 0,
    marginTop: -1,
    height: 140,
    marginStart: -11,
    marginEnd: -1,
  },
  headerTitleContainer: {
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    width: '100%',
  },
  headerTitle: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 17,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    lineHeight: 24,
    letterSpacing: -0.1,
    textAlign: 'center',
    color: colors.primary,
    alignSelf: 'center',
    flexDirection: 'row',
  },
  stickyHeader: {
    height: 24,
    backgroundColor: colors.grey30,
    shadowColor: colors.grey50,
    shadowOffset: {
      width: 0,
      height: -0.5
    },
    shadowRadius: 0,
    shadowOpacity: 1,
  },
  stickyTitle: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 13,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    lineHeight: 20,
    letterSpacing: 0.1,
    color: colors.grey70,
    paddingHorizontal: isTablet() || Platform.OS === 'web' ? 30 : 15,
  },
  popoverContainer: {
    backgroundColor: colors.grey20,
    borderRadius: 8,
    paddingHorizontal: 10,
    paddingBottom: 16,
    flex: 1,
  },
});

export default BrowseScreen;
